import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

/** Returns the requested query params from current url */
export function useQueryParams<T extends string>(keys: T[]): (string | null)[] {
  const { search } = useLocation()
  return useMemo(() => {
    const params = new URLSearchParams(search)
    return keys.map((key) => params.get(key))
  }, [search, keys])
}
